"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useInfiniteScroll = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactInfiniteScrollComponent = _interopRequireDefault(require("react-infinite-scroll-component"));
var _useOnScreen = require("../../lib/hooks/useOnScreen");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var useInfiniteScroll = _ref => {
  var items = _ref.items,
    chunkSize = _ref.chunkSize,
    component = _ref.component;
  var totalItems = items.length;
  var _useState = (0, _react.useState)(1),
    _useState2 = _slicedToArray(_useState, 2),
    chunk = _useState2[0],
    setChunk = _useState2[1];
  var chunkedComponents = (0, _react.useMemo)(() => {
    return items.slice(0, chunkSize * chunk).map(item => component(item));
  }, [chunk, chunkSize, items, component]);
  var resetChunk = (0, _react.useCallback)(() => setChunk(1), [setChunk]);
  var totalRendered = chunkedComponents.length;
  var hasMore = totalRendered < totalItems;
  var InfiniteScrollWrapper = (0, _react.useMemo)(() => _ref2 => {
    var children = _ref2.children,
      className = _ref2.className;
    var handleNext = () => setChunk(chunk + 1);
    return /*#__PURE__*/_react.default.createElement(_reactInfiniteScrollComponent.default, {
      className: className,
      dataLength: chunkSize,
      next: handleNext,
      hasMore: hasMore,
      loader: hasMore && /*#__PURE__*/_react.default.createElement(Loader, {
        onVisible: handleNext
      }),
      style: {
        overflow: 'hidden'
      }
    }, children);
  }, [chunk, chunkSize, hasMore]);
  return {
    InfiniteScrollWrapper,
    chunkedComponents,
    resetChunk
  };
};

/**
 * react-infinite-scroll-component is sometimes a little bit flaky when
 * you first load the page. This component makes sure that the user will always
 * render at least as many components as they can see on the screen.
 */
exports.useInfiniteScroll = useInfiniteScroll;
var Loader = /*#__PURE__*/(0, _react.memo)(_ref3 => {
  var onVisible = _ref3.onVisible;
  var ref = (0, _react.useRef)(null);
  var isVisible = (0, _useOnScreen.useOnScreen)(ref);
  (0, _react.useEffect)(() => {
    if (isVisible) {
      onVisible();
    }
  }, [isVisible, onVisible]);
  return /*#__PURE__*/_react.default.createElement("div", {
    ref: ref
  });
});
//# sourceMappingURL=useInfiniteScroll.js.map